/* Reads our passive availability record only; never probes JLR. */
(function () {
  'use strict';
  var banner = document.getElementById('oem-vin-service-banner');
  if (!banner) return;
  var pending = false;
  async function refresh() {
    if (pending || document.hidden) return;
    pending = true;
    try {
      var response = await fetch('/apps/vin/service-status', { cache: 'no-store' });
      if (!response.ok) return;
      var status = await response.json();
      // Unknown / failed reads cannot clear an already visible warning.
      if (status.disrupted === true) banner.hidden = false;
      else if (status.disrupted === false) banner.hidden = true;
    } catch (_) {
      // Status delivery must not interrupt storefront use.
    } finally { pending = false; }
  }
  refresh();
  setInterval(refresh, 60000);
  document.addEventListener('visibilitychange', refresh);
  window.addEventListener('oem:vin-lookup-complete', refresh);
})();
